<template>
  <div class="login-box" v-show="isShow" ref="loading">
    <p>登录领取红包</p>
    <ul>
      <li>
        <input type="text" class="phone" v-model="tel" placeholder="请输入手机号" />
      </li>
      <li>
        <input type="text" class="code" v-model="smsCode" placeholder="请输入验证码" />
        <!-- <span>重新发送 (120)</span> -->
        <span @click="getCode" :class="isYzmDisable ? 'disabled' : ''">{{info}}</span>
      </li>
    </ul>
    <input type="button" class="btn" @click="loginFn" :disabled="isDisable" value="立即登录" />
    <div class="close" @click="close"></div>
  </div>
</template>

<script>
import $ from "jquery"
export default {
  name: 'loginbox',
  props: [
    'isShow',
    'isPath'
  ],
  data(){
    return {
      tel: '',  //手机号
      smsCode: '',   //验证码
      loginType: 1,
      timer: null,  //定时器
      info: '获取验证码',
      isDisable: true,
      isYzmDisable: true
    }
  },
  created() {
    window.onload = function () {
        var  windowHeight= $(window).height();//获取窗口的可见高度,不是整个文档的高度
        var screenHeight = window.screen.availHeight;//获取浏览器的屏幕的可用高度
        //alert(windowHeight+','+window.screen.availHeight);

        var u = navigator.userAgent;

        if (u.indexOf('Android') > -1 || u.indexOf('Linux') > -1) {
            if (windowHeight <= screenHeight / 2) {
                $('.btn-fix').css({'position': 'absoult', 'display': 'none'});
            } else {
                $('.btn-fix').css({'position': 'fixed', 'display': 'block'});
            }
        }
        $(".phone").on('focus', function () {
            $('.btn-fix').hide();
        })
        $(".phone").on('blur', function () {
            $('.btn-fix').show();
        })
        $(".code").on('focus', function () {
            $('.btn-fix').hide();
        })
        $(".code").on('blur', function () {
            $('.btn-fix').show();
        })
    }
    //alert($(window).height());
    //alert(window.screen.availHeight);
    
  },
  watch: {
    tel: function(val){
      if(val.length === 11 && /^[1][0-9]{10}$/.test(val)){
        this.isYzmDisable = false
      }else{
        this.isYzmDisable = true
      }
    },
    smsCode: function(val){
      if(!this.isYzmDisable && val.length === 6 && /^\d{6}$/.test(val)){
        this.isDisable = false
      }else{
        this.isDisable = true
      }
    }
  },
  methods: {
    close(){
      this.$emit('closeFn', false)
    },
    getCode(){
      if(this.isYzmDisable) return
      if(this.info !== '获取验证码') return
      if(this.timer) clearInterval(this.timer)
      let time = 120
      this.timer = setInterval(() => {
        if(time <= 0){
          clearInterval(this.timer)
          this.info = '获取验证码'
          this.smsCode = ''
          return
        }
        time--
        this.info = `重新发送 (${time})`
      }, 2000)
      this.$loading.show({
        el: this.$refs.loading
      })
      this.axiosPost('mobile/check',{ // 检查手机号是否已经注册过
        mobileNo: this.tel
      }).then((res) => {
        if(res.data.attachment.notMobileNo === 0){ // 登录
          this.loginType = 1
        } else if (res.data.attachment.notMobileNo === 1){
          this.loginType = 2
        }
        this.axiosPost('sms/send',{ // 发送验证码
          mobileNo: this.tel,
          type: this.loginType
        }).then((res) => {
          this.$loading.hide()
        })
      })
    },
    loginFn(){
      if(this.isDisable) return
      this.$loading.show({
        el: this.$refs.loading
      })
      let wxopenid = localStorage.getItem('wxopenid') ? localStorage.getItem('wxopenid') : ''
      let authType = localStorage.getItem('authType') ? localStorage.getItem('authType') : ''
      // console.log('login', wxopenid)
      // console.log('login', authType)
      this.axiosPost('login',{ // 登录
        phoneNum: this.tel,
        passwd: '',
        smsCode: this.smsCode,
        loginType: 1,
        authType: authType,
        authId: wxopenid
      }).then((res) => {
        localStorage.setItem('uid', res.data.attachment.uid)
        localStorage.setItem('token', res.data.attachment.token)
        this.close()
        this.$loading.hide()
        if (this.isPath) {
          this.$router.push({path: '/redpacket', query: this.$route.query})
        } else {
          this.$router.push({path: '/tgplan', query: this.$route.query})
        }
      })
    }
  }
}
</script>

<style lang="stylus" scoped>
  .login-box
    width 5.8rem
    height 5.88rem
    background #fff
    border-radius .3rem
    padding .4rem .3rem 0 .4rem
    box-sizing border-box
    position fixed
    z-index 99999
    top 0
    left 0
    bottom 0
    right 0
    margin auto
    display flex
    flex-direction column
    justify-content flex-start
    align-items flex-start
    .close
      position absolute
      cursor pointer
      width .38rem
      height .38rem
      background url('/images/close.png') no-repeat
      background-size 100% auto
      right .3rem
      top .4rem
    p
      font-size .3rem
      color #333
      height .42rem
      line-height .42rem
    ul 
      margin-top .2rem
      li
        height 1.32rem
        width 5rem
        margin 0 auto
        line-height .42rem
        border-bottom 1px solid #F0F0F0
        display flex
        align-items center
        justify-content space-between
        input[type="text"]
          border none
          height .6rem
          font-size .3rem
          margin-left .05rem
          &::placeholder
            color #E1E1E1
        &:first-child
          span
            font-size .3rem
            line-height .3rem
            color #888
            padding-right .1rem
            border-right 1px solid #cccccc
        &:last-child
          input[type="text"]
            width 2rem
            margin-right .3rem
          span
            font-size .3rem
            color #333
            cursor pointer
            &.disabled
              color #ccc
    .btn
      margin-top .4rem
</style>
